<template>
    <div class="w-screen h-screen flex flex-col justify-center items-center gap-6">
        <h1 class="text-[100px] font-bold text-secondary">
            404
        </h1>
        <div class="flex flex-col items-center gap-2 text-disabled">
            <h2 class="text-2xl font-bold">
                Oops!
            </h2>
            <p class="text-sm">
                Page not found
            </p>
            <router-link to="/dashboard">
                <Button variant="secondary" class="mt-4" leading-icon="chevron-left">
                    Go back to homepage
                </Button>
            </router-link>
        </div>
    </div>
</template>

<script setup lang="ts">
import Button from '@/vue/components/design-system/button/Button.vue'
</script>
